module.exports = __webpack_public_path__ + "img/top_1.cfe2ed06.jpg";